import { OptionsApi } from '@core/swagger-client/src/OptionsApi';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/$linkCode')({
    // The webinar for the document title: this route is not under /$webinarId. prefetchQuery, not ensureQueryData:
    // an unknown or expired link is WatchLinkPage's to show, not the router's error page.
    loader: async ({ params, context }) => {
        const query = OptionsApi.watchLink.getWebinar({ linkCode: params.linkCode });
        await context.queryClient.prefetchQuery(query);
        return { webinar: context.queryClient.getQueryData(query.queryKey) };
    }
});
